/**
 * Created by Pankaj on 27-Sep-2019
 */
import {WalkingWildView} from "./WalkingWildView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {RomanEmpireParsedGameData} from "../server/data/RomanEmpireParsedGameData";
import {RomanEmpireParsedInitData} from "../server/data/RomanEmpireParsedInitData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {TimelineLite} from "gsap";
import {RomanEmpireGameMode} from "../gamemode/RomanEmpireGameMode";
import {RomanEmpireEvents} from "../events/RomanEmpireEvents";
import {ISymbolPositions} from "../winpresentation/geniefeature/GenieFeatureController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {IReelStoppedData, IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";

export interface IWalkingWildData {
    reelId: number,
    symbolId: number,
    isNewWild: boolean,
    multiplier: number,
    nextMultiplier: number
    isGoldenGenie: boolean,
    isDefaultGoldenGenie: boolean,
    isHandOver: boolean
}

export interface IGoldenGenieData {
    goldenGenieMultiplierNextSpin: number
    isNoGenieSpin: boolean,
    goldenGeniePosNext: ISymbolPositions,
    goldenGeniePos: ISymbolPositions
}

export class WalkingWild {

    private _view: WalkingWildView;
    private _walkingWildsMap: Map<string, IWalkingWildData> = new Map<string, IWalkingWildData>();
    private _walkingWildsMapPrev: Map<string, IWalkingWildData> = new Map<string, IWalkingWildData>();
    private _isGenieFeatureTriggered: boolean = false;
    private _isBrokenReSpin: boolean = false;
    private _timeline: TimelineLite;
    private _isFirstReSpin: boolean = false;
    private _reelDelayArr: number[] = [];
    private _finalMultiplierData: IWalkingWildData | undefined;
    private _goldenGenieData: IGoldenGenieData = new class implements IGoldenGenieData {
        goldenGenieMultiplierNextSpin: number;
        goldenGeniePos: ISymbolPositions;
        goldenGeniePosNext: ISymbolPositions;
        isNoGenieSpin: boolean;
    };
    private _goldenGenieDataPrev: IGoldenGenieData = new class implements IGoldenGenieData {
        goldenGenieMultiplierNextSpin: number;
        goldenGeniePos: ISymbolPositions;
        goldenGeniePosNext: ISymbolPositions;
        isNoGenieSpin: boolean;
    };
    public static IS_HANDOVER : boolean = false;
    public static IS_FINAL_MULTIPLIER_MOVING : boolean = false;
    private _genieFeatureM3Pos : ISymbolPositions = {reelId : -1, symbolId : -1};

    constructor() {
        this.addEventListeners();
        this._view = new WalkingWildView();
    }

    private addEventListeners(): void {
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STARTED, (event: GameEvent) => this.onAllReelsSpinStarted());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.onBeforeSpinStarted());
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_SCATTER_REVEAL, (event: GameEvent) => this.onScatterRevealComplete());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event: GameEvent) => this.onAllReelsSpinStopped());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_REEL_STOP_SPIN, (event: GameEvent) => this.onReelStopSpinStarted(event.params[0], event.params[1], event.params[2]));
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_REEL_BOUNCE, (event: GameEvent) => this.onBounce(event.params[0]));
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_STOP_SPIN, (event: GameEvent) => this.onReelStopSpin(event.params[0]));
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_BIG_WIN_ANIM_START, (event: GameEvent) => this.onBigWinAnimStart());

    }

    private onBigWinAnimStart(){
        this._view.resetLayer();
    }

    private onReelStopSpin(data: IReelStoppedData) {
        if (this._goldenGenieData.isNoGenieSpin) {
            this._finalMultiplierData = this.getWildsDataByReelIdAndSymId(this._goldenGenieData.goldenGeniePos.reelId, this._goldenGenieData.goldenGeniePos.symbolId);
        }
    }

    private onBounce(data: IReelStoppedData) {
        if (this._goldenGenieData.isNoGenieSpin) {
            const isGenieReel: boolean = this._finalMultiplierData?.reelId == data.reelId;
            this._view.onBounce(this._reelDelayArr, data,  this._genieFeatureM3Pos, this._finalMultiplierData, isGenieReel);
        }
    }

    private onReelStopSpinStarted(reelId: number, delay: number, stopData: IReelStopSpinData) {//onReelStopSpinStarted
        if (this._goldenGenieData.isNoGenieSpin) {
            this._reelDelayArr[reelId] = delay;
            reelId == 4 && this._view.playFinalMultiplierAnimOverReel(this._reelDelayArr);
        }
    }

    private storePrevData() {
        this._walkingWildsMapPrev = new Map(this._walkingWildsMap);
        Object.assign(this._goldenGenieDataPrev, this._goldenGenieData);
    }

    private onBeforeSpinStarted() {
        this._view.resetLayer();
        this.storePrevData();
        (this._isFirstReSpin || !this._isGenieFeatureTriggered) && this.createWalkingWild(this._walkingWildsMapPrev);
        //this._view.playLeftMostWildOutAnim(this._goldenGenieDataPrev);
    }

    private onScatterRevealComplete() {
        if(this._goldenGenieData.isNoGenieSpin && this._isGenieFeatureTriggered){
            this._view.finalMultiplierOnFeatureTriggered(this._finalMultiplierData);
        }
        this.createWalkingWild(this._walkingWildsMap);
    }

    private createWalkingWild(walkingWilds: Map<string, IWalkingWildData>) {
        if (walkingWilds.size) {
            this._view.createAndShowWalkingWilds(walkingWilds);
        }
    }

    private onAllReelsSpinStarted() {
        this.startPresentation();
    }

    private startPresentation(): void {
        if (this._timeline?.isActive()) {
            this._timeline.pause().kill();
        }
        this._timeline = new TimelineLite({paused: true});
        this._timeline.add(this._view.startPresentation(this._goldenGenieDataPrev));
        this._timeline.play();
    }

    private onGameDataParsed(data: RomanEmpireParsedGameData) {
        this._isBrokenReSpin = false;
        this._goldenGenieData.isNoGenieSpin = data.isNoGenieSpin;
        this.parseCommonData(data);
        this._isFirstReSpin = data.mode == RomanEmpireGameMode.NORMAL && data.isNextGenieReSpin;
        if (data.mode == RomanEmpireGameMode.GENIE_RESPIN || data.isNextGenieReSpin) {
            this.setWalkingWildsData(data.walkingWildsScatterPositions, false, data.wildMultipliers, data.wildMultipliersNextSpin);
            this.setWalkingWildsData(data.newOverlayWilds, true, data.wildMultipliers, data.wildMultipliersNextSpin);
        }
        this._isGenieFeatureTriggered = data.isGenieFeatureTriggered;
        this._genieFeatureM3Pos.reelId = -1;
        this._genieFeatureM3Pos.symbolId = -1;
        // if(this._isGenieFeatureTriggered){
        //     //genieSymbolTriggerPositions
        //     for (let i = 0; i < data.reels.length; i++) {
        //         const scatterPos : number = data.reels[i].indexOf("S");
        //         if(scatterPos != -1){
        //             break;
        //         }
        //         if(i == 0) continue;
        //         const m3Pos : number = data.reels[i].indexOf("M3");
        //         if(m3Pos != -1 && data.reels[i-1][m3Pos] == "M2"){
        //             this._genieFeatureM3Pos.reelId = i;
        //             this._genieFeatureM3Pos.symbolId = m3Pos;
        //         }
        //     }
        // }
    }

    private onInitDataParsed(data: RomanEmpireParsedInitData) {
        this.parseCommonData(data);
        if (data.mode == RomanEmpireGameMode.GENIE_RESPIN || data.isNextGenieReSpin) {
            this._isBrokenReSpin = true;
            this.setWalkingWildsData(data.walkingWildsScatterPositions, true, data.wildMultipliers, data.wildMultipliersNextSpin);
        }
    }

    private onAllReelsSpinStopped() {
        if (!this._walkingWildsMap.size) {
            this.stopPresentation();
        }
    }

    private parseCommonData(data: RomanEmpireParsedGameData | RomanEmpireParsedInitData) {
        this._goldenGenieData.goldenGenieMultiplierNextSpin = data.goldenGenieMultiplierNextSpin;
        this._goldenGenieData.goldenGeniePos = {
            reelId: data.goldenGeniePositionCurrent[0],
            symbolId: data.goldenGeniePositionCurrent[1]
        };
        this._goldenGenieData.goldenGeniePosNext = {
            reelId: data.goldenGeniePositionNextSpin[0],
            symbolId: data.goldenGeniePositionNextSpin[1]
        };
        this.reset();
    }

    private stopPresentation() {
        this._view.stopPresentation();
    }

    /**
     * To set walking wild array from server response to play view animations.
     * @param walkingWildsData
     * @param isNewWild : used param to get a new wild land on reel.
     * @param wildMultipliers : used param for Multiplier value.
     * @param wildMultipliersNextSpin : used param for next spin multiplier value.
     */
    private setWalkingWildsData(walkingWildsData: boolean[][], isNewWild: boolean, wildMultipliers: number[][], wildMultipliersNextSpin: number[][]): void {
        let scatterOnFirstReelIndex: number = -1;
        if (this._isFirstReSpin) {
            scatterOnFirstReelIndex = walkingWildsData[0].indexOf(true);
        }
        walkingWildsData.forEach((positions: boolean[], reelId: number) => {
            positions.forEach((value: boolean, symbolId: number) => {
                if (value) {
                    const position: IWalkingWildData = {
                        reelId: reelId,
                        symbolId: symbolId,
                        isNewWild: isNewWild,
                        multiplier: wildMultipliers[reelId][symbolId] || 0,
                        nextMultiplier: wildMultipliersNextSpin ? (reelId == 0 ? 0 : wildMultipliersNextSpin![reelId - 1][symbolId]) : 0,
                        isHandOver: reelId == 0 && !this._goldenGenieData.isNoGenieSpin,
                        isDefaultGoldenGenie: scatterOnFirstReelIndex != -1 ? (scatterOnFirstReelIndex == symbolId && reelId == 0) : this.isDefaultGoldenGenie(reelId, symbolId),
                        isGoldenGenie: (reelId == this._goldenGenieData.goldenGeniePos.reelId && symbolId == this._goldenGenieData.goldenGeniePos.symbolId)
                    };
                    this._walkingWildsMap.set(reelId + "" + symbolId, position);
                }
            })
        });
    }

    private isDefaultGoldenGenie(reelId: number, symbolId: number) {
        if ((this._isFirstReSpin || this._isBrokenReSpin || this._goldenGenieData.isNoGenieSpin) && (reelId == this._goldenGenieData.goldenGeniePos.reelId && symbolId == this._goldenGenieData.goldenGeniePos.symbolId)) {
            return true;
        }
        return false;
    }

    private reset() {
        this._walkingWildsMap.clear();
        this._reelDelayArr = [0, 0, 0, 0, 0];
    }

    private getWildsDataByReelIdAndSymId(reelId: number, symId: number) {
        return this._walkingWildsMap.get(reelId + "" + symId);
    }
}